import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FolderOpen, Copy, Trash2, Pencil } from 'lucide-react';
import { po, apiError } from '../api';

export default function PoTemplates() {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState([]);

  const load = () => po.get('/templates').then((r) => setTemplates(r.data));
  useEffect(() => { load(); }, []);

  const openDraft = (t) => navigate('/quote/po/new', { state: { template: t } });
  const rename = async (t) => {
    const name = window.prompt('New template name:', t.name);
    if (!name || name === t.name) return;
    try { await po.patch(`/templates/${t.id}`, { name }); load(); } catch (e) { alert(apiError(e)); }
  };
  const dup = async (t) => {
    try { await po.post(`/templates/${t.id}/duplicate`); load(); } catch (e) { alert(apiError(e)); }
  };
  const del = async (t) => {
    if (!window.confirm(`Delete template "${t.name}"?`)) return;
    try { await po.delete(`/templates/${t.id}`); load(); } catch (e) { alert(apiError(e)); }
  };

  return (
    <div className="p-6 md:p-8" data-testid="po-templates-page">
      <h1 className="text-xl font-bold text-[#14233F] mb-6">PO Templates</h1>
      <div className="bg-white border border-slate-200 rounded overflow-x-auto">
        <table className="w-full text-sm min-w-[700px]">
          <thead>
            <tr className="text-[11px] uppercase tracking-wider text-slate-500 border-b border-slate-200">
              <th className="text-left px-4 py-3 font-semibold">Name</th>
              <th className="text-left px-4 py-3 font-semibold">Entity</th>
              <th className="text-left px-4 py-3 font-semibold">Supplier</th>
              <th className="text-right px-4 py-3 font-semibold">Lines</th>
              <th className="text-left px-4 py-3 font-semibold">Last updated</th>
              <th className="text-right px-4 py-3 font-semibold">Actions</th>
            </tr>
          </thead>
          <tbody>
            {templates.map((t) => (
              <tr key={t.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 font-semibold text-slate-800">{t.name}</td>
                <td className="px-4 py-3 mono text-xs text-slate-500 uppercase">{t.entity_id}</td>
                <td className="px-4 py-3 text-slate-600">{t.supplier_id}</td>
                <td className="px-4 py-3 mono text-right">{t.items?.length || 0}</td>
                <td className="px-4 py-3 mono text-xs text-slate-500">{t.updated_at?.slice(0, 10)}</td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-3">
                    <button onClick={() => openDraft(t)} title="Open in new draft" className="inline-flex items-center gap-1 text-xs text-[#0F7D70] hover:underline" data-testid={`po-tpl-open-${t.id}`}>
                      <FolderOpen className="h-3.5 w-3.5" /> Open
                    </button>
                    <button onClick={() => rename(t)} title="Rename" data-testid={`po-tpl-rename-${t.id}`}><Pencil className="h-4 w-4 text-slate-300 hover:text-slate-700" /></button>
                    <button onClick={() => dup(t)} title="Duplicate" data-testid={`po-tpl-dup-${t.id}`}><Copy className="h-4 w-4 text-slate-300 hover:text-[#0F7D70]" /></button>
                    <button onClick={() => del(t)} title="Delete" data-testid={`po-tpl-del-${t.id}`}><Trash2 className="h-4 w-4 text-slate-300 hover:text-red-600" /></button>
                  </div>
                </td>
              </tr>
            ))}
            {templates.length === 0 && (
              <tr><td colSpan="6" className="px-4 py-10 text-center text-slate-400 text-sm">No templates yet — save one from the PO editor.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
